<template>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
        <section :class="this.name">
            <div id="shineSide-bg" class="player cover"></div>
            <div class="bg"></div>
            <div class="content">
                <div class="cont">
                    <h2>샤인 사이드</h2>
                    <p>진 카마엘이 방어와 회복에 특화 되어 있는 상태</p>
                    <p>생명체가 가지고 있는 영혼 중 빛의 영혼을 극대화 하여 흡수하고, 전투 시 방어와 회복에 특화된 상태로 변화시킨다.</p>
                </div>
            </div>
        </section>
    </transition>
</template>
<script>
    import BasePage from "./mixins/basePage.js";
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';

    export default {
        name: "shineSide",
        mixins: [BasePage],
        data() {
            return {
                name: "shineSide",
                contentData: [
                    {type: "bg", source: this.$staticUrl + "img/bg_4.jpg", objName: "bg"},
                    {type: 'bgChrCon'},
                ],
                mouseX:0,
                isMouseMove:false,
                moveMotion1:null,
                moveMotion2:null,
                moveMotionType:''
            };
        },
        methods: {
            canvasSet() {
                this.bgPlayer = new nc.promokit.Player({
                    selector: '#shineSide-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/shine.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer.pause();
                TweenMax.set(this.$el.querySelector('#shineSide-bg'), {autoAlpha:0});
                this.baseCavasSet(this.contentData);

                this.cvObj.chr1Con = new PIXI.Container();
                this.cvObj.chr1Con.x = this.documentSetSize.width/2-284;
                this.cvObj.chr1Con.y = 120;

                this.cvObj.chr1Box = new PIXI.Container();

                this.cvObj.bgChrCon.addChild(this.cvObj.chr1Con);
                this.cvObj.chr1Con.addChild(this.cvObj.chr1Box);

                this.cvObj.chr1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/obj_4_1.png');
                this.cvObj.chr1Ef = new PIXI.Sprite.fromImage(this.$staticUrl+'img/obj_4_1_ef.png');
                canvasObjPosition(this.cvObj.chr1, this.cvObj.chr1Box, 0, 0);
                canvasObjPosition(this.cvObj.chr1Ef, this.cvObj.chr1Box, 273, 521);


                // TweenMax.set(this.cvObj.chr1Con, {pixi: { blur: 2}})
                // TweenMax.set(this.cvObj.chr1Box, {pixi: { scale: 0.5, x:-70, y:130}})
                // TweenMax.set(this.cvObj.chr1Box, {pixi: { scale: 0.75, x:-70, y:130}})

                this.cvObj.chr2Con = new PIXI.Container();
                this.cvObj.chr2Con.x = this.documentSetSize.width/2+390;
                this.cvObj.chr2Con.y = 145;

                this.cvObj.chr2Box = new PIXI.Container();

                this.cvObj.bgChrCon.addChild(this.cvObj.chr2Con);
                this.cvObj.chr2Con.addChild(this.cvObj.chr2Box);


                this.cvObj.bgChrCon.addChild(this.cvObj.chr2Con);

                this.cvObj.chr2 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/obj_4_2.png');
                this.cvObj.chr2Ef = new PIXI.Sprite.fromImage(this.$staticUrl+'img/obj_4_2_ef.png');
                canvasObjPosition(this.cvObj.chr2, this.cvObj.chr2Box, 0, 0);
                canvasObjPosition(this.cvObj.chr2Ef, this.cvObj.chr2Box, -260, 354);

                // TweenMax.set(this.cvObj.chr2Con, {pixi: { blur: 2}})
                // TweenMax.set(this.cvObj.chr2Box, {pixi: { scale: 0.5, x:15, y:130}})
                //TweenMax.set(this.cvObj.chr2Box, {pixi: { scale: 0.75, x:15, y:130}})

                this.cvObj.txtTitleCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleCon);
                this.cvObj.txtTitle = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_4_tit.png');
                canvasObjPosition(this.cvObj.txtTitle, this.cvObj.txtTitleCon, this.contentSize.w/2, 414);
                this.cvObj.txtTitleLineCon = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txtTitleLineCon);
                this.cvObj.txtTitleLine = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_4_tit_line.png');
                canvasObjPosition(this.cvObj.txtTitleLine, this.cvObj.txtTitleLineCon, this.contentSize.w/2, 545);

                this.cvObj.txt1Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt1Con);
                this.cvObj.txt1 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_4_txt_1.png');
                canvasObjPosition(this.cvObj.txt1, this.cvObj.txt1Con, this.contentSize.w/2, 580);

                this.cvObj.txt2Con = new PIXI.Container();
                this.cvObj.con.addChild(this.cvObj.txt2Con);
                this.cvObj.txt2 = new PIXI.Sprite.fromImage(this.$staticUrl+'img/txt_4_txt_2.png');
                canvasObjPosition(this.cvObj.txt2, this.cvObj.txt2Con, this.contentSize.w/2, 616);


                this.canvas.ticker.add(()=> {
                    if(!this.isMouseMove)return;
                    let centerNum = this.documentSetSize.width/2;
                    let playType;
                    if((centerNum - this.mouseX) < 0){
                        playType = 'play';
                    }else{
                        playType = 'reverse';
                    }

                    if(this.moveMotionType != playType){
                        this.moveMotionType = playType;
                        if(this.moveMotionType == 'play'){
                            this.moveMotion1.reverse();
                            this.moveMotion2.play();
                        }else{
                            this.moveMotion1.play();
                            this.moveMotion2.reverse();
                        }

                    }
                });



            },
            enter(el, done) {
                this.baseEnter();
                this.canvasSet();
                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion
                    .fromTo(this.cvObj.bgChrCon, 1.5, {pixi: {y: 100, brightness: 0,  blur: 10}}, { pixi: {y: 0,  brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    //.fromTo(this.cvObj.chr1Con, 2, {pixi: { brightness: 0,  blur: 10}}, { pixi: { brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.chr1Box, 1.5, {pixi: {alpha:0}}, { pixi: {alpha:1},ease:Sine.easeOut}, 'bgMotionEnd-=0.2')
                    //.fromTo(this.cvObj.chr2Con, 2, {pixi: { brightness: 0,  blur: 10}}, { pixi: { brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.chr2Box, 1.5, {pixi: {alpha:0}}, { pixi: {alpha:1},ease:Sine.easeOut, onComplete:()=>{this.mouseMoveSet();}}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.txtTitleCon, 1.3, {pixi: { brightness: 3}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitleLine, 0.5, {pixi: { alpha: 0, scale:0}}, {pixi:{scale:1, alpha:1}, ease:Back.easeOut}, 'bgMotionEnd+=0.7')
                    .fromTo(this.cvObj.txt1, 0.7, {pixi: { alpha: 0, scale:0.1}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt1Con, 0.7, {pixi: { blurX: 50}}, {pixi:{blurX:0}}, 'bgMotionEnd+=0.9')
                    .fromTo(this.cvObj.txt2, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=1.3')
                    .fromTo(this.cvObj.txt2Con, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}, onComplete:()=>{
                            this.moveMotion1.timeScale(1)
                            this.moveMotion2.timeScale(1)
                        }}, 'bgMotionEnd+=1.3')
                    .call(()=>{
                        this.bgPlayer.seek(0.6);
                        this.bgPlayer.play();
                        TweenMax.set(this.$el.querySelector('#shineSide-bg'), {autoAlpha:1})
                    }, null, null, 'bgMotionEnd+=0')
                    .to(this.cvObj.bg, 0.5, {pixi: { alpha: 0}, delay:0.5 }, 'bgMotionEnd+=0');


                this.enterMotion.play();


                TweenMax.set(this.cvObj.chr1Box, {x:-90, y:260,pixi:{ scale: 0.55}})
                TweenMax.set(this.cvObj.chr1Con, {pixi:{ blur: 2,  brightness: 0.5}})
                TweenMax.set(this.cvObj.chr1Ef, {pixi:{ alpha: 0}})

                TweenMax.set(this.cvObj.chr2Box, {x:65, y:260,pixi:{ scale: 0.55}})
                TweenMax.set(this.cvObj.chr2Con, {pixi:{ blur: 2,  brightness: 0.5}})
                TweenMax.set(this.cvObj.chr2Ef, {pixi:{ alpha: 0}})

                this.moveMotion1 = new TimelineLite({paused:true});
                this.moveMotion2 = new TimelineLite({paused:true});
                this.moveMotion1
                    .to(this.cvObj.chr1Box, 1, {
                        bezier:{
                            curviness:2,
                            autoRotataion:true,
                            values:[{x:-140, y:130}, {x:0, y:0}]
                        },
                        ease:Power3.easeInOut}
                    )
                    .to(this.cvObj.chr1Box, 1, {pixi:{ scale: 1},ease:Power3.easeInOut}, '-=1')
                    .to(this.cvObj.chr1Con, 1, {pixi:{ blur: 0,  brightness: 1},ease:Power3.easeInOut}, '-=1')
                    .to(this.cvObj.chr1Ef, 0.5, {pixi:{ alpha:1},ease:Bounce.easeOut}, '-=0.5')

                this.moveMotion2
                    .to(this.cvObj.chr2Box, 1, {
                        bezier:{
                            curviness:2,
                            autoRotataion:true,
                            values:[{x:115, y:130}, {x:0, y:0}]
                        },
                        ease:Power3.easeInOut}
                    )
                    .to(this.cvObj.chr2Box, 1, {pixi:{ scale: 1},ease:Power3.easeInOut}, '-=1')
                    .to(this.cvObj.chr2Con, 1, {pixi:{ blur: 0,  brightness: 1},ease:Power3.easeInOut}, '-=1')
                    .to(this.cvObj.chr2Ef, 0.5, {pixi:{ alpha:1},ease:Bounce.easeOut}, '-=0.5')

                this.moveMotion1.seek(0.5)
                this.moveMotion2.seek(0.5)
                this.moveMotion1.timeScale(0.5)
                this.moveMotion2.timeScale(0.5)

                window.addEventListener("mousemove", this.mouseMove);
            },
            leave(el, done) {
                if (this.enterMotion) this.enterMotion.pause();
                this.baseLeaveMotion(el, done);
                window.removeEventListener("mousemove", this.mouseMove);
            },
            mouseMoveSet(){
                this.isMouseMove = true;

            },
            mouseMove(e){
                this.mouseX = e.clientX;
            },
            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.bg, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);

                this.cvObj.chr1Con.x = this.documentSetSize.width/2-284;
                this.cvObj.chr2Con.x = this.documentSetSize.width/2+390;

                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        }
    };
</script>

